import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EmbeddedRoadmapEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const embeddedRoadmapEntryPoint: EntryPoint<EmbeddedRoadmapEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<EmbeddedRoadmapEntryPointComponent>(
			/* webpackChunkName: "async-polaris-embedded-roadmap-entrypoint" */ './PolarisEmbeddedRoadmapPage.tsx',
		),
		getPreloadProps: () => ({}),
	});
